import React, { useEffect, useMemo, useReducer } from 'react'
import { Autocomplete, TextField } from '@mui/material'
import CircularProgress from '@mui/material/CircularProgress';
import timeoutList from './TimeoutList';
import { lockedReducer } from './reducers';

const modifyInternalData = (initializeOptions, data) => {
    const options = []
    if (!initializeOptions) return data
    options.push(...initializeOptions)
    const options_ids = options.map(option => option?.id)
    data.forEach(item => {
        if (!options_ids.includes(item?.id)) options.push(item)
    })
    return options
}

const MegaAutoComplete = ({ multiple = false, value, onChange, noOptionsText, timeoutUrl,
    timeoutParam, label, widthInput, disabled = false, replace = {}, internal = () => { }, initializeOptions,
filterOptions, autoload=false, disableInput=false, test=false}) => {

    const [state, setState] = useReducer(lockedReducer, {
        data: [],
        smallLoading: false
    })

    internal(state, setState)

    const options = useMemo(() => modifyInternalData(initializeOptions, state.data), [state.data, initializeOptions])

    useEffect(()=>{
        if (autoload)
            timeoutList('', timeoutUrl, 'data', timeoutParam || 'name', setState)
    }, [autoload])

    return (
        <Autocomplete
            multiple={multiple}
            disabled={disabled}
            sx={{ flex: 1 }}
            //id={'megaautocompletebox'}
            value={value}
            options={filterOptions ? filterOptions(options) : options}
            onChange={(e, selectedData) => onChange(selectedData)}
            autoHighlight
            filterSelectedOptions
            handleHomeEndKeys
            clearText='Limpar'
            noOptionsText={noOptionsText || 'Digite para pesquisar'}
            loading={state.smallLoading}
            ChipProps={{ size: 'small' }}
            onOpen={() => state.data.length === 0 && timeoutList('', timeoutUrl, 'data', timeoutParam || 'name', setState)}
            onInputChange={(e, v) => { e?.type === 'change' && !disableInput && timeoutList(v, timeoutUrl, 'data', timeoutParam || 'name', setState) }}
            renderInput={(params) =>
                <TextField
                    {...params}
                    //id={'autocompleteinput'}
                    type="text"
                    sx={{ width: widthInput ? widthInput : '100%' }}
                    label={label || ''}
                    size="small"
                    fullWidth={true}
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <>
                                {state.smallLoading ? <CircularProgress color="inherit" size={20} /> : null}
                                {params.InputProps.endAdornment}
                            </>
                        ),
                    }}
                />
            }
            {...replace}
        />
    )
}

export default MegaAutoComplete